import qs from 'qs';
import Http from '../../lib/Http';
import { User, Account } from './types';

const TOKEN_KEY = 'AccessToken';
const EDITOR_TOKEN_KEY = 'EditorToken';

export async function getUserMe() {
	const response = await Http.get<User>(
		`/users/me`
	);
	return response.data;
}

export async function getAccountMe() {
	const response = await Http.get<Account>(
		`/accounts/me`
	);
	return response.data; 
}

export async function requestLogin(data: any) {
	const response = await Http.post<string>(
		`/signin`,
		qs.stringify(data),
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			}
		}
	);
	return response.data;
}

export function getSavedToken() {
	return window.localStorage.getItem(TOKEN_KEY);
}


export function saveToken(token:string) {
	window.localStorage.setItem(TOKEN_KEY, token);
}

export function saveEditorToken(token:string) {
	window.localStorage.setItem(EDITOR_TOKEN_KEY, token);
}

export function removeToken() {
	window.localStorage.removeItem(TOKEN_KEY);
}


export interface Billing {
	availableCount: number;
	billingDate: Date;
	billingType: number;
	currentPlan: number;
	lmsCount: number;
	nextPlan: number;
	plan: number;
	renewalDate: Date;
	smsCount: number;
	subscriberCount: number;
}
